import type { ValidationRule } from "@vuelidate/core";
import { email, required } from "@vuelidate/validators";
import type { ContactFormState } from "~/modules/shared/components/contactForm/ContactForm.types";

export const CONTACT_FORM_FIELDS = {
  EMAIL: "email",
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
  MESSAGE: "message",
  NEWSLETTER_CONSENT: "newsletterConsent",
  SUBJECT: "subject",
} as const;

export const CONTACT_FORM_VALIDATION_RULES: Partial<
  Record<keyof ContactFormState, Record<string, ValidationRule>>
> = {
  email: { email, required },
  firstName: { required },
  lastName: { required },
  message: { required },
  subject: { required },
};
